module.exports = __webpack_public_path__ + "54c80a4d.svg";